<!-- eslint-disable vue/attribute-hyphenation -->
<template>
  <v-card v-if="casoDeUso" class="mx-4 mt-4">
    <v-row align-content="space-between">
      <v-col cols="6">
        <v-card-title class="font-weight-bold">{{ this.projeto }}</v-card-title>
        <div class="text-h5 ml-4">{{ charter.identificacao }}</div>
      </v-col>

      <v-col cols="6">
        <v-card-actions class="d-flex justify-end">
          <div>
            <EditCharter
              v-if="isQA"
              @charter-editado="getCharter"
              :id="this.id"
              :charter="this.charter"
            />
          </div>
          <div class="mx-3">
            <DeleteCharter v-if="isQA" :id="this.id" />
          </div>
        </v-card-actions>
      </v-col>
    </v-row>
    <div class="ml-4 text-subtitle-2 mt-1 mb-2">
      <span>
        Status:
        <span class="font-weight-bold mr-2">{{
          converterEnumParaTexto(charter.status_charter)
        }}</span>
      </span>
    </div>
    <!-- <v-card-subtitle class="mb-2"> </v-card-subtitle> -->

    <div class="mt-4 ml-4">
      <RouterLink
        :to="
          '/projects/' + this.idProjeto + '/CasoUso/' + casoDeUso.id_caso_de_uso
        "
      >
        <v-btn color="grey-darken-3" variant="tonal">Caso de Uso</v-btn>
      </RouterLink>
      <RouterLink
        :to="'/sprints/backlog/' + sprint + '/tarefa/' + tarefa.id_tarefa"
      >
        <v-btn class="ml-2" color="grey-darken-3" variant="tonal">Tarefa</v-btn>
      </RouterLink>
    </div>
    <div class="mt-3 mx-4">
      <div class="mt-1 mb-2 text-light-blue-darken-4">Objetivo</div>
      <div class="rounded-sm bg-grey-lighten-4 px-1 py-2">
        <p class="ml-2 text-body-1">{{ charter.objetivo }}</p>
      </div>
      <div class="mt-1 mb-2 text-light-blue-darken-4">Pré-condição</div>
      <div class="rounded-sm bg-grey-lighten-4 px-1 py-2">
        <p class="ml-2 text-body-1">{{ charter.pre_condicao }}</p>
      </div>
      <div class="mt-1 mb-2 text-light-blue-darken-4">Observação</div>
      <div class="rounded-sm bg-grey-lighten-4 px-1 py-2">
        <p class="ml-2 text-body-1">{{ charter.observacao }}</p>
      </div>
    </div>
    <!-- <v-card-text class="mt-2">
      <div class="text-h6 mb-1">Objetivo</div>
      {{ charter.objetivo }}
      <div class="text-h6 my-1">Pré-condição</div>
      {{ charter.pre_condicao }}
      <div class="text-h6 my-1">Observação</div>
      {{ charter.observacao }}
    </v-card-text> -->
    <div class="bg-light-blue-darken-4 my-4 mydivider mx-4"></div>

    <v-row align-content="center">
      <v-card-title class="mx-3 font-weight-bold mt-4"
        >Áreas de Concentração</v-card-title
      >
      <CreateAreaConcentracao
        v-if="isQA"
        @area-concentracao-adicionada="getAreasConcentracao"
        class="mt-8 mb-4"
        :id="this.id"
      />
    </v-row>

    <AreaConcentracao
      @area-concentracao-editada="getAreasConcentracao"
      @area-concentracao-removida="getAreasConcentracao"
      class="mb-4"
      v-for="(areaC, index) in areasConcentracao"
      :key="areaC.descricao"
      :area="areaC"
      :index="index"
      :csu="casoDeUso"
    ></AreaConcentracao>
  </v-card>

  <v-container v-if="this.isLoading" class="d-flex justify-center align-center">
    <v-progress-circular class="text-center" indeterminate size="20" />
  </v-container>
</template>
<script>
/**
 * @module Charter
 * @desc Tabela que mostra a lista de requisitos por ID projeto.
 * @vue-data {number} [idProjeto=?] - O ID do projeto.
 * @vue-data {number} [id=null] - O ID do Caso de Uso.
 * @vue-data {Object} [charter=null] - O Charter do CSU.
 * @vue-data {Object} [casoDeUso=null] - O CSU.
 * @vue-data {Object} [tarefa=null] - A tarefa.
 * @vue-data {Array} [areasConcentracao=[]] - A lista das areas de concentração.
 * @vue-data {boolean} [isLoading=false] - Indica se o charter
 * está sendo carregado ou não
 * @vue-data {String} [projeto=''] - Nome do projeto.
 * @vue-computed {Boolean} isQA - Flag que indica se o usuário
 * atual é testador no projeto.
 */
import axios from 'axios';

import AreaConcentracao from '@/components/AreaConcentracao.vue';
import CreateAreaConcentracao from '@/components/dialogs/CreateAreaConcentracao.vue';
import DeleteCharter from '@/components/dialogs/DeleteCharter.vue';
import EditCharter from '@/components/dialogs/EditCharter.vue';
import store from '@/store/store';

const apiUrl = process.env.VUE_APP_API_URL;
export default {
  components: {
    EditCharter,
    DeleteCharter,
    AreaConcentracao,
    CreateAreaConcentracao,
  },
  name: 'TelaCharter',
  data() {
    return {
      idProjeto: this.$route.params.idProjeto,
      projeto: '',
      charter: null,
      casoDeUso: null,
      tarefa: null,
      areasConcentracao: [],
      id: null,
      isLoading: false,
      sprint: null,
    };
  },
  created() {
    this.id = this.$route.params.id;
    this.projeto = localStorage.getItem('projeto');
    this.getCharter(this.id);
    this.getAreasConcentracao(this.id);
  },
  computed: {
    isQA() {
      return localStorage.getItem('formaAtuacao') === '"TESTADOR"';
    },
  },
  methods: {
    /**
     * Formata as strings do enum;
     */
    converterEnumParaTexto(string) {
      /// STATUS
      if (string === 'PLANEJADO') {
        return 'Planejado';
      } else if (string === 'BLOQUEADO') {
        return 'Bloqueado';
      } else if (string === 'EXECUTADO') {
        return 'Executado';
      }
    },
    /**
     * Formata as strings do enum;
     */
    converterTextoParaEnum(string) {
      /// STATUS
      if (string === 'Planejado') {
        return 'PLANEJADO';
      } else if (string === 'Bloqueado') {
        return 'BLOQUEADO';
      } else if (string === 'Executado') {
        return 'EXECUTADO';
      }
    },
    /**
     * Faz uma requisição HTTP para buscar o
     * charter pelo seu ID.
     *
     * @param {Number} id O id do charter.
     */
    async getCharter(id) {
      this.isLoading = true;
      try {
        const response = await axios.get(`${apiUrl}/api/v1/charters/${id}`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        });
        this.charter = response.data.charter;
        console.log(response.data.charter);
        this.getCasoDeUso(this.charter.id_caso_de_uso);
        this.getTarefa(this.charter.id_tarefa);
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
    /**
     * Faz uma requisição HTTP para pegar o CSU.
     *
     * @param {Number} id O id do CSU.
     */
    async getCasoDeUso(id) {
      try {
        const response = await axios.get(
          `${apiUrl}/api/v1/productBacklog/${id}`,
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`,
            },
          },
        );
        this.casoDeUso = response.data.useCase;
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * Faz uma requisição HTTP para pegar a
     * tarefa por seu id.
     *
     * @param {Number} id O id da tarefa.
     */
    async getTarefa(id) {
      try {
        const response = await axios.get(`${apiUrl}/tarefas/${id}`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        });
        // console.log(response.data.tarefa);
        this.tarefa = response.data.tarefa;
        // console.log(this.tarefa.tb_itembacklogsprint.length);
        if (this.tarefa.tb_itembacklogsprint.length != 0) {
          this.sprint = this.tarefa.tb_itembacklogsprint[0].id_sprint;
        } else {
          this.sprint = null;
        }
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * Faz uma requisição HTTP para buscar as
     * areas de concentração.
     *
     * @param {Number} id O id do charter.
     */
    async getAreasConcentracao(id) {
      try {
        const response = await axios.get(
          `${apiUrl}/api/v1/areaConcentracao/charter/${id}`,
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`,
            },
          },
        );
        this.areasConcentracao = response.data.areaC;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
<style scoped>
.wrapper-buttons {
  /* border: 1px solid red; */
  display: flex;
  justify-content: end;
}
.depItem {
  font-weight: bold;
  font-size: 12px;
  padding-bottom: 4px;
  padding-left: 0.5rem;
  padding-top: 4px;
  border-radius: 2px;
  margin-left: 1rem;
  /* border-bottom: 1px solid grey; */
}

.depItem:hover {
  background-color: rgba(156, 156, 156, 0.756);
  cursor: pointer;
}
.middleLine {
  width: 1px;
  background-color: grey;
}

.conteinerDep {
  height: 200px;
  overflow-y: scroll;
}

.mydivider {
  height: 2px;
}
</style>
